/**
 * DATOS DE EQUIPOS - SPRINT 2
 * 
 * Este archivo contiene toda la información de los equipos para el dashboard de análisis.
 * Datos recopilados el 5-8 de Marzo de 2026.
 */

import type { SprintEvaluation, Felicitacion } from './teamsData';

// ========================================
// DATOS DE SPRINT 2 - 46 respuestas
// ========================================
export const sprint2Data: SprintEvaluation[] = [
  // === EQUIPO 1 ===
  {
    memberId: "e1-1-s2",
    memberName: "Medina Hernández Ramón",
    teamId: 1,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Aceptable",
    quality: "Excelente",
    objectivesCompleted: "Bueno",
    selfEvaluation: 4,
    tasksCompleted: "Conexión de la BD a Supabase, peticiones de Postman, cursos compartidos de MongoDB (MongoDB University).",
    blockers: "No saber como avanzar con la BD (otra vez JAJA), bueno, despúes de la conexión con supabase y de hacer las peticiones en postman, ya entendí mejor como funciona esa conexión con la base de datos, yo creo que ya con la próxima practica en el laboratorio de modificar el HTML y TypeScript va a ser mas fluido el trabajo.",
    areasToImprove: "Conocimientos de MongoDB, TypeScript y HTML.",
    nextSprintFocus: "Empezar a diseñar el código de TypeScript para empezar a hacer consultas con el login, siento que la practica del martes va a ser importante y después de ver como funciona GITHUB, el código va a ser más fácil para modificar entre todos.",
    improvementProposals: "Quizá una mejor comunicación, por ejemplo, en el caso de Angel que hizo todo el código de la Landing Page, yo no sabía que lo estaba haciendo todo, pero cosas así, de ahi en fuera, los trabajos en laboratorio son buenas, conectamos y entendemos bien las ideas de cada uno de los integrantes (aunque Zaira no fue a la última practica).",
  },
  {
    memberId: "e1-2-s2",
    memberName: "Hernández Peña Angel Adrian",
    teamId: 1,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Excelente",
    selfEvaluation: 3,
    tasksCompleted: "Herramientas de IA para profundizar del proyecto. Diagrama E-R (versión 2). Peticiones a la entidad \"usuarios\". Iniciación del dialogo con alumnos y docentes de pedagogía para la revisión y compartir ideas para el proyecto.",
    blockers: "Literal, me bloqueó :(. En general, hace falta más conocimiento para el equipo y tiempo además de compromiso.",
    areasToImprove: "Conocimientos en Mongo y Phaser.",
    nextSprintFocus: "Diseño de Login/Sign Up/Forgot password.",
    improvementProposals: "Uso de herramientas de IA para mejorar la productividad y compartir la visión del proyecto.",
  },
  {
    memberId: "e1-3-s2",
    memberName: "Gil De Gaona Jazmín",
    teamId: 1,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Excelente",
    selfEvaluation: 3,
    tasksCompleted: "Diagrama entidad relación, documentación, get, push, delete de \"Examen\".",
    blockers: "Mi medicamento.",
    areasToImprove: "Mongo.",
    nextSprintFocus: "Mongo.",
    improvementProposals: "Nada.",
  },
  {
    memberId: "e1-4-s2",
    memberName: "Buenrostro Cruces Sarai",
    teamId: 1,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Realice el primer diagrama ER, ya despues lo modificaron y cambiaron unas partes que le hacian falta en el salon de clases. Igual que las peticiones en postman de los juegos.",
    blockers: "Ninguno.",
    areasToImprove: "Profundizar mis conocimientos en sql.",
    nextSprintFocus: "En la bd.",
    improvementProposals: "Estamos bien.",
  },
  {
    memberId: "e1-5-s2",
    memberName: "Zaira Cecilia Perez Lopez",
    teamId: 1,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 3,
    tasksCompleted: "Colaboracion en el diseño E-R del sistema, y contribucion en diseño de la base de datos NO-SQL de la entidad \"Juegos\".",
    blockers: "Vivir lejos y faltar al Laboratorio.",
    areasToImprove: "Asistencia y puntualidad.",
    nextSprintFocus: "Diseño del Front y mejoras en el diseño de la base.",
    improvementProposals: "Mas cursos para mejorar las habilidades y estar en el mismo canal para entregas de sprint y no estar mas en un area que en otra.",
  },

  // === EQUIPO 2 ===
  {
    memberId: "e2-1-s2",
    memberName: "Antonio Velazquez Martinez",
    teamId: 2,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Una ayuda regular (a mi criterio) al momento de crear el diagrama entidad-relacion e implementarla al supabase.",
    blockers: "Ninguna.",
    areasToImprove: "Vamos perfecto hasta el momento.",
    nextSprintFocus: "Mejorar un poquis la documentacion, creo que pudo ser mejor.",
    improvementProposals: "Andamos perfectos, mejoramos la comunicacion.",
  },
  {
    memberId: "e2-2-s2",
    memberName: "Carlos Emiliano Segura Loera",
    teamId: 2,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Le ayude a mi compañero Samuel explicandole como hacer las peticiones del Postman.",
    blockers: "Tiempo.",
    areasToImprove: "Falta de conocimientos de APIS y la teoria.",
    nextSprintFocus: "Entregar el trabajo mas rapido.",
    improvementProposals: "Que los integrantes si vayan a clase 😅.",
  },
  {
    memberId: "e2-3-s2",
    memberName: "Moctezuma Ramirez Diego Rafael",
    teamId: 2,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Creación del diagrama E-R, ayudé a la creación de la base en supabase y en la redacción del reporte.",
    blockers: "Tiempo.",
    areasToImprove: "Usar de una forma más organizada el trello.",
    nextSprintFocus: "Mejorar la comunicación.",
    improvementProposals: "",
  },
  {
    memberId: "e2-4-s2",
    memberName: "Saúl Villeda López",
    teamId: 2,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Petición desde postman simulando un usuario.",
    blockers: "Ninguno.",
    areasToImprove: "Practicar más los temas de clase.",
    nextSprintFocus: "Experiencia de usuario de los vendedores.",
    improvementProposals: "Ninguna por el momento.",
  },
  {
    memberId: "e2-5-s2",
    memberName: "Herrera Franco Samuel",
    teamId: 2,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 4,
    tasksCompleted: "Peticiones postman con ayuda de compañeros.",
    blockers: "Mal manejo de tiempo.",
    areasToImprove: "Todo.",
    nextSprintFocus: "Hacer la vista front de la pagina.",
    improvementProposals: ".",
  },

  // === EQUIPO 3 ===
  {
    memberId: "e3-1-s2",
    memberName: "Emiliano Ruiz Garcia",
    teamId: 3,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Aceptable",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Contribución en general con el LAB 03 en cuestión del uso de Postman. Contribución fundamental en la elaboración del diagrama entidad relación del equipo, con clara comunicación con los miembros del equipo.",
    blockers: "Paros de comunicación en días de examen de otras materias.",
    areasToImprove: "Organización temporal con todas mis obligaciones y materias.",
    nextSprintFocus: "La API en general del proyecto.",
    improvementProposals: "Mayor comunicación, en especial con el compañero Angel, que lo he notado desconectado del equipo a veces.",
  },
  {
    memberId: "e3-2-s2",
    memberName: "Monserrat Guadalupe Del Angel Santiago",
    teamId: 3,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Realizacion del diagrama entidad relacion conforme a la guia de requisitos, realizacion de peticiones en postman.",
    blockers: "Ninguno.",
    areasToImprove: "Algunos conceptos de Git.",
    nextSprintFocus: "Crear la estructura HTML para el material de estudio, conectar la base de datos para mostrar el material de estudio y crear la lógica para añadir el material de estudio.",
    improvementProposals: "Mejorar aun mas la comunicacion para que el trabajo colaborativo sea aun mejor y se distribuyan las actividades de manera equitativa.",
  },
  {
    memberId: "e3-3-s2",
    memberName: "StudyLink",
    teamId: 3,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Aceptable",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Diagrama entidad-relación, creación de la base en Supabase, los endpoints de todas las entidades en Supabase y endpoits en postman de entidad usuarios.",
    blockers: "La falta de compromiso de un integrante del equipo.",
    areasToImprove: "Comunicación con todos y aprender mas funcionalidades del git.",
    nextSprintFocus: "HTML en git y otras cosas de git.",
    improvementProposals: "Comunicación.",
  },
  {
    memberId: "e3-4-s2",
    memberName: "Jose Angel Raygoza Islas",
    teamId: 3,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Aceptable",
    quality: "Aceptable",
    objectivesCompleted: "Aceptable",
    selfEvaluation: 3,
    tasksCompleted: "Se me asigno hacer un post.",
    blockers: "Siento que es mas de mi parte seguir practicando y buscar videos mas detallados.",
    areasToImprove: "Conocimiento en las plataformas que usamos.",
    nextSprintFocus: "Seguir preparándome.",
    improvementProposals: "Es pero mas comunicación :).",
  },

  // === EQUIPO 4 ===
  {
    memberId: "e4-1-s2",
    memberName: "Josue Trinidad Potrero",
    teamId: 4,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "A mi me toco hacer la implementacion de la BD a supabase, poner las imagenes de supabase en el documento y hacer los metodos en postman.",
    blockers: "Un poco lo de postman.",
    areasToImprove: "Darle un repaso a postman.",
    nextSprintFocus: "Ser un poco mas ingenioso a la hora de designar los valores de las entidades de nuestra BD, tipo checar si estan bien nuestras relaciones y si no hay rebundancia en nuestros datos.",
    improvementProposals: "Siento que un plus para nuestro equipo seria la comunicacion por que aveces nos hacemos bolas entre nosotros mismos.",
  },
  {
    memberId: "e4-2-s2",
    memberName: "Martínez Rodríguez Fernando",
    teamId: 4,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 5,
    tasksCompleted: "Ayude con ideas del modelo ER, hice las configuraciones del postman para las peticiones y asignación de tareas en Clickup.",
    blockers: "Asignar tareas y explicaciones a mis compañeros sobre los diferentes metodos de postman.",
    areasToImprove: "A lo mejor la forma en que explico las cosas.",
    nextSprintFocus: "En el codigo.",
    improvementProposals: "Un poco mas disposición de parte de Daniela y Pamela, ya que siento que se esperan a que ya todos elijamos o ya este todo elegido o incluso completo para decir \"que hacemos\" o \"en que ayudamos\".",
  },
  {
    memberId: "e4-3-s2",
    memberName: "Bruno Aguilar Buendía",
    teamId: 4,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Código de la DB en supabase, peticiones en postman de la tabla tutores y realización del diagrama e-r.",
    blockers: "Ninguno.",
    areasToImprove: "Utilizar postman bien.",
    nextSprintFocus: "En el front y back end.",
    improvementProposals: "Asignar de mejor manera las tareas.",
  },
  {
    memberId: "e4-4-s2",
    memberName: "Daniela Itzel Mendoza Hernandez",
    teamId: 4,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 4,
    tasksCompleted: "En este sprint logré aportar aún más al equipo, un poco más de manera teórica al resolver el diagrama ER.",
    blockers: "Aún las partes prácticas me cuestan y aún logro \"perder el miedo\".",
    areasToImprove: "Falta de práctica en SQL y todo lo de supabase, Se me complica bastante el compréndelo a la hora de las practicas.",
    nextSprintFocus: "Fuera de las actividades de clase, poner más en práctica todo lo que hasta el momento hemos visto.",
    improvementProposals: "Tener aún más comunicación.",
  },

  // === EQUIPO 5 ===
  {
    memberId: "e5-1-s2",
    memberName: "Alitzel Sophia Camacho Flores",
    teamId: 5,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Endpoints para la tabla Usuario. Construcción del proyecto en supabase. Organización general del equipo.",
    blockers: "Otros proyectos no me dejaron tanto tiempo para ver el avance de mis compañeras y terminar antes el trabajo.",
    areasToImprove: "Aprender más sobre endpoint y appis y como construirlos en postman.",
    nextSprintFocus: "Trabajar en el frontend de nuestra página.",
    improvementProposals: "Avanzar más con las actividades desde que se asignan y no dejarlas para último momento.",
  },
  {
    memberId: "e5-2-s2",
    memberName: "Cristina Vianeth Saiz Perez",
    teamId: 5,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Cada parte del Sprint participamos todas equitativamente.",
    blockers: "Al momento ninguno.",
    areasToImprove: "Solo git.",
    nextSprintFocus: "Aun no visualizo el sprint.",
    improvementProposals: "Hay poca accesibilidad entre las chicas en algunas situaciones.",
  },
  {
    memberId: "e5-3-s2",
    memberName: "Ximena Toledo Mendez",
    teamId: 5,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Definir las relaciones con sus respectivas cardinalidades.",
    blockers: "Ninguno.",
    areasToImprove: "Falta de conocimientos en normalización.",
    nextSprintFocus: "Aplicar los temas del Lab 2 a nuestro proyecto (CRUD).",
    improvementProposals: "Comunicación.",
  },
  {
    memberId: "e5-4-s2",
    memberName: "Chávez González Itzel",
    teamId: 5,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 4,
    tasksCompleted: "Entidades para el Diagrama ER y mi parte en Postman.",
    blockers: "Ninguno.",
    areasToImprove: "Sigue siendo conocimientos en SQL.",
    nextSprintFocus: "Poder aportar más al equipo.",
    improvementProposals: "Mejor planeación del tiempo.",
  },

  // === EQUIPO 6 ===
  {
    memberId: "e6-1-s2",
    memberName: "Libonatti Valdivia Sadrach Neftali",
    teamId: 6,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Creacion de endpoints, analisis del modelo de tablas relacionales para el proyecto.",
    blockers: "Ninguno, como tal, vamos al ritmo de la clase.",
    areasToImprove: "Mejorar mis skills, en lo que viene, front, o lo que toque.",
    nextSprintFocus: "En el punto visual de la app, y la interacion del usuario.",
    improvementProposals: "Mas reuniones.",
  },
  {
    memberId: "e6-2-s2",
    memberName: "González Sánchez Raúl Alejandro",
    teamId: 6,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Ayude a hacer el supabase y al momento de pasarlo al postman, también hice mis respectivas endpoints.",
    blockers: "Mi bajo entendimiento del supabase.",
    areasToImprove: "Falta de conocimiento en el uso de los verbos básicos (get,push,put,delete).",
    nextSprintFocus: "Hacer todo lo que pueda lo mejor posible.",
    improvementProposals: "Ponernos más de acuerdo en la división de trabajos.",
  },
  {
    memberId: "e6-3-s2",
    memberName: "Michelle Moctezuma Isidro",
    teamId: 6,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Los 4 requests en Postman, ya investigué más acerca de las herramientas.",
    blockers: "Falta de tiempo.",
    areasToImprove: "Practicar más peticiones.",
    nextSprintFocus: "Hacer código.",
    improvementProposals: "Llevar un agenda.",
  },
  {
    memberId: "e6-4-s2",
    memberName: "Elías García Luis David",
    teamId: 6,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 4,
    tasksCompleted: "Modulo de Autenticación (Modelo), Esqueleto de Proyecto de Front End (Configuración Básica sin vistas).",
    blockers: "Entidades e interacciones aun no bien definidas.",
    areasToImprove: "Comunicación.",
    nextSprintFocus: "FrontEnd.",
    improvementProposals: "Planeación.",
  },

  // === EQUIPO 7 ===
  {
    memberId: "e7-1-s2",
    memberName: "Rodríguez Rodríguez Erick Tadeo",
    teamId: 7,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Me encargué del modelo entidad relación y apoyar con postman y supabase.",
    blockers: "No creo que tuviera impedimentos.",
    areasToImprove: "Más comunicación con mi team pero es algo que estoy trabajando.",
    nextSprintFocus: "Más en la programación de la base de datos.",
    improvementProposals: "Posiblemente más comunicación.",
  },
  {
    memberId: "e7-2-s2",
    memberName: "Cruz Chávez Miguel Ángel",
    teamId: 7,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Participe en las peticiones a los endpoints sobre la base de datos creada en supabase.",
    blockers: "Ninguno, he estado al corriente con lo que se solicita.",
    areasToImprove: "Mejorar un poco la division de tareas.",
    nextSprintFocus: "Quiero enfocarme en el backend.",
    improvementProposals: "Por el momento creo que no, creo que mejoramos en la parte de comunicación.",
  },
  {
    memberId: "e7-3-s2",
    memberName: "Armando Hernández González",
    teamId: 7,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Mis contribuciones fueron los test en postman.",
    blockers: "Un poco la falta de tiempo por las demás materias.",
    areasToImprove: "Creo que debo mejorar mis conocimientos en SQL.",
    nextSprintFocus: "Aun no se.",
    improvementProposals: "Hasta el momento ninguna, nos hemos organizado bien.",
  },
  {
    memberId: "e7-4-s2",
    memberName: "Arturo Tadeo Moreno Vigueras",
    teamId: 7,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Cree la base de datos para supabase además de la migración con los Put, además de eso estuve arreglando la asignación de tareas a lo largo del sprint.",
    blockers: "La carga de trabajo en otras materias y mi servicio social.",
    areasToImprove: "Administrar mucho mejor mis tiempos.",
    nextSprintFocus: "La mera verdad no se, ya que no esta el documento para saber que vamos a hacer. (Si lo pudiera volver a subir estaría fantástico.)",
    improvementProposals: "El esperarnos hasta el lab donde hacemos el verdadero trabajo del sprint nos hace retrasarnos por que se nos juntan cosas de las demás materias y si no es que se nos olvida actualizar el Jira, ya que nos solemos comunicar por WhatsApp.",
  },
  {
    memberId: "e7-5-s2",
    memberName: "Monserrat Hernández Martínez",
    teamId: 7,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Recolección de Datos y Normalización de tablas.",
    blockers: "Falta de bases.",
    areasToImprove: "Git.",
    nextSprintFocus: "Git y GitHub.",
    improvementProposals: "Cómo equipo compartimos y trabajamos muy bien.",
  },
  {
    memberId: "e7-6-s2",
    memberName: "Marquez Espinoza Alyn Veronica",
    teamId: 7,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Aceptable",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Documentación del diagrama ER.",
    blockers: "La organización de tareas.",
    areasToImprove: "Entendimos de páginas utilizadas.",
    nextSprintFocus: "Investigar más las páginas que utilizamos.",
    improvementProposals: "Comunicación.",
  },

  // === EQUIPO 8 ===
  {
    memberId: "e8-1-s2",
    memberName: "González Hernández Leslie Danaé",
    teamId: 8,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Comencé el bosquejo del diagrama entidad - relación, colaborando se logró completar. En Supabase me encargue de cargar tablas y agregar registros.",
    blockers: "En Postman fue un poco complicado, pero logre entender la interface.",
    areasToImprove: "Falta de conocimientos en Supabase.",
    nextSprintFocus: "Planeo enfocarme en Postman.",
    improvementProposals: "El único incoveniente que noto, es la organización de la reunión semanal, por cuestiones de horarios no congeniamos tanto, pero con la comunicación logramos superar el obstáculo.",
  },
  {
    memberId: "e8-2-s2",
    memberName: "Baez Villanueva Mauricio Omar",
    teamId: 8,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Apoyo a la realización del diagrama de entidades y realización de peticiones en postaman de la tabla postulaciones.",
    blockers: "Ninguno.",
    areasToImprove: "Habilidades en SQL.",
    nextSprintFocus: "En implementar los primeros módulos del backend.",
    improvementProposals: "Ya planeamos reuniones en zoom para realizar los sprints.",
  },
  {
    memberId: "e8-3-s2",
    memberName: "Vanesa Sebastian Cervantes",
    teamId: 8,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Creación de endpoints, aplicación de metodos put, push, patch, delete, get.",
    blockers: "Nada.",
    areasToImprove: "Mejorar mi ingles para entender las plataformas.",
    nextSprintFocus: "Organizar mi tiempo.",
    improvementProposals: "Todo bien.",
  },
  {
    memberId: "e8-4-s2",
    memberName: "Herrera Hernández Diego",
    teamId: 8,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Bueno",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Yo revise mas cosas sobre la arquitectura de la base de datos más que nada, lo que tiene que ver con la escalabilidad, y las tablas padre encargados y sus hijos empresa y profesores y un poquito mas.",
    blockers: "Me ganaron la chamba jajajaja, afortunadamente el equipo es muy participativo, únicamente hubo un poco mas de delay en la comunicación pero de ahí todo bien.",
    areasToImprove: "Pues creo que lo único seria agendar días específicos para reuniones pero en la reunión de hoy ya se aclaro ese punto así que no estaría del todo seguro, estoy mas que seguro que el equipo se pondrá y se esta poniendo a la altura.",
    nextSprintFocus: "Pues yo me encargo de explicar algunas cosas técnicas que a veces no se comprenden del todo, me gastaría seguir enfocándome en eso para que en general el equipo mejore, cosa que ya han hecho pues justo el martes explicaron algo sin mi ayuda y lo hicieron bien.",
    improvementProposals: "A decir verdad esta vez me tarde un poco en proponer la comunicación del equipo para ponerse de acuerdo en entregar este laboratorio, pero no estoy seguro en que otra área podríamos mejorar, puede que sea bueno ir más allá de lo que se nos pide inicialmente.",
  },

  // === EQUIPO 9 ===
  {
    memberId: "e9-1-s2",
    memberName: "Romero Velazquez Luis Fernando",
    teamId: 9,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Aceptable",
    quality: "Aceptable",
    objectivesCompleted: "Aceptable",
    selfEvaluation: 4,
    tasksCompleted: "Diagrama.",
    blockers: "Tiempo en equipo.",
    areasToImprove: "Mi tiempo.",
    nextSprintFocus: "En html.",
    improvementProposals: "Un poco mas de tiempo para estar todo el equipo.",
  },
  {
    memberId: "e9-2-s2",
    memberName: "Cortes Cortes Bryan Yael",
    teamId: 9,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Aceptable",
    quality: "Aceptable",
    objectivesCompleted: "Aceptable",
    selfEvaluation: 4,
    tasksCompleted: "Implementación en Supabase. Agregar los links de algunos los endpoints de Supabase.",
    blockers: "Acoplarme a supabase aún más.",
    areasToImprove: "Justo eso, mejorar mi desarrollo en supabase.",
    nextSprintFocus: "Enpoints.",
    improvementProposals: "Mejor comunicación, y mejor planeamiento del trabajo, no dejar todo al ultimo.",
  },
  {
    memberId: "e9-3-s2",
    memberName: "Ríos Barrera Arantza Ilian",
    teamId: 9,
    sprint: 2,
    productivity: "Bajo",
    collaboration: "Bajo",
    quality: "Aceptable",
    objectivesCompleted: "Aceptable",
    selfEvaluation: 4,
    tasksCompleted: "Corrección del diagrama ER, Todas las peticiones del postman y por consiguiente la colección.",
    blockers: "Falta de repuesta por mensaje del equipo, poca proactividad de algunos compañeros, tener que editar sus partes del trabajo, el que acaben sus partes del trabajo completas y a tiempo.",
    areasToImprove: "Manejar mejor el postman, aprender a relacionar mejor las entidades.",
    nextSprintFocus: "Mejor Calidad de trabajo, división equitativa de tareas y el cumplimiento de estas.",
    improvementProposals: "Comunicación, No tener que estar editando las partes del trabajo de los demás compañeros, Compromiso.",
  },
  {
    memberId: "e9-4-s2",
    memberName: "Valdovinos Sedano Daniela Ariday",
    teamId: 9,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 4,
    tasksCompleted: "Realizar la parte del Postman.",
    blockers: "Falta de tiempo.",
    areasToImprove: "Falta de conocimientos en general.",
    nextSprintFocus: "Más organizacion para un mejor resultado.",
    improvementProposals: "Hacerlo con más tiempo porque procastinamos jajaj.",
  },
  {
    memberId: "e9-5-s2",
    memberName: "Romero Velazquez Luis Fernando (2)",
    teamId: 9,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "El diagrama en mi IA y sus relaciones que tenían las tablas.",
    blockers: "Nop.",
    areasToImprove: "Me gustaría saber mas de sql.",
    nextSprintFocus: "Aprender mas de sql.",
    improvementProposals: "Todo bien.",
  },

  // === EQUIPO 10 ===
  {
    memberId: "e10-1-s2",
    memberName: "Jesús Alvarez Casas",
    teamId: 10,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Bueno",
    quality: "Bueno",
    objectivesCompleted: "Bueno",
    selfEvaluation: 3,
    tasksCompleted: "Realice el pdf entregable juntando el trabajo de los demas miembros y asigne algunas actividades a compañeros.",
    blockers: "Un poco los conceptos que usan, aun no estoy tan familiarizados con todos.",
    areasToImprove: "Falta de conocimientos en APIs y cosas así.",
    nextSprintFocus: "En hacer algo mas importante que juntar el trabajo de todos y hacer el entregable.",
    improvementProposals: "Una mejor comunicación.",
  },
  {
    memberId: "e10-2-s2",
    memberName: "Rodrigo Rojas Uriositigue",
    teamId: 10,
    sprint: 2,
    productivity: "Bajo",
    collaboration: "Aceptable",
    quality: "Aceptable",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Realicé el diagrama entidadad relación, definí de forma bien los endpoints. Uní a mis compañeros al supabase para que pudieran hacer las peticiones, de igual forma me encargue de hacer la carga de la Base de datos a Supabase junto con los registros.",
    blockers: "Sinceramente mi compañero Guillermo no estuvo colaborando en nada, la tarea pudo estar lista desde antes pero no hacía su parte que era las peticiones individuales para el entregable y pues durante la planeación del proyecto el se dedicaba a estar en otras cosas.",
    areasToImprove: "Siento que ya viene la parte del diseño de la página y ese no es mi fuerte, entonces ponerme a estudiar frontend.",
    nextSprintFocus: "Planeación del front y checar como se va a conectar.",
    improvementProposals: "Que colaboremos todos mas activamente.",
  },
  {
    memberId: "e10-3-s2",
    memberName: "Leonardo Daniel Velazquez Garcia",
    teamId: 10,
    sprint: 2,
    productivity: "Bueno",
    collaboration: "Aceptable",
    quality: "Bueno",
    objectivesCompleted: "Excelente",
    selfEvaluation: 4,
    tasksCompleted: "Peticiones mias por el postman y ayuda al SQL y a los inserts en supabase.",
    blockers: "Tiempo por trabajo.",
    areasToImprove: "Saber mas SQL y manejar mejor el postman.",
    nextSprintFocus: "SQL.",
    improvementProposals: "Quiero presentar una queja de mi compañero de equipo Guillermo ya que, en el Lab1 tan solo le costo hasta el ultimo dia darnos su nombre, y en este no hizo nada durante las clases, se pasaba viendo deportes. Y las peticiones de postman si es que las entrega las entrego hasta el ultimo momento, y solo por que le estuvimos presionando.",
  },
  {
    memberId: "e10-4-s2",
    memberName: "Luna Martínez Escobar Guillermo",
    teamId: 10,
    sprint: 2,
    productivity: "Excelente",
    collaboration: "Excelente",
    quality: "Excelente",
    objectivesCompleted: "Excelente",
    selfEvaluation: 5,
    tasksCompleted: "Hice la organizacion completa de trello, hice un cronograma del mundial en supabase también.",
    blockers: "La agilidad en las plataformas nuevas, ya que las conozco sere más rapido en futuros sprints.",
    areasToImprove: "Necesito practica en supabase no conocia la plataforma.",
    nextSprintFocus: "Planeo enfocarme en trello supabase, un cronograma web del mundial.",
    improvementProposals: "Elephant sql.",
  },
  {
    memberId: "e10-5-s2",
    memberName: "Martínez Hernández Ricardo Ramón",
    teamId: 10,
    sprint: 2,
    productivity: "Aceptable",
    collaboration: "Aceptable",
    quality: "Aceptable",
    objectivesCompleted: "Aceptable",
    selfEvaluation: 5,
    tasksCompleted: "Peticiones get, put, push y delete a la tabla \"evento\".",
    blockers: "En general las intrucciones de este sprint fueron bastante claras, así que no tuve mayor complicación.",
    areasToImprove: "Hacer todos los trabajos a tiempo y no a ultima hora.",
    nextSprintFocus: "Quiero ahondar más en los temas y no solo hacer la práctica y ya.",
    improvementProposals: "Comunicación y puntualidad.",
  },
];

// ========================================
// FELICITACIONES SPRINT 2 - Actualizar cada sprint
// ========================================
export const sprint2Felicitaciones: Felicitacion[] = [
  // Sprint 2
  { from: "Libonatti Valdivia Sadrach Neftali", fromTeam: 6, to: "Michelle", sprint: 2 },
  { from: "Josue Trinidad Potrero", fromTeam: 4, to: "Fernando", sprint: 2 },
  { from: "Josue Trinidad Potrero", fromTeam: 4, to: "Pamela", sprint: 2 },
  { from: "Emiliano Ruiz Garcia", fromTeam: 3, to: "Estefani Lira", sprint: 2 },
  { from: "Monserrat Guadalupe Del Angel Santiago", fromTeam: 3, to: "Ninguno", sprint: 2 },
  { from: "StudyLink", fromTeam: 3, to: "Emiliano", sprint: 2 },
  { from: "Martínez Rodríguez Fernando", fromTeam: 4, to: "Bruno", sprint: 2 },
  { from: "Martínez Rodríguez Fernando", fromTeam: 4, to: "Josué", sprint: 2 },
  { from: "Medina Hernández Ramón", fromTeam: 1, to: "Todos por igual", sprint: 2 },
  { from: "Hernández Peña Angel Adrian", fromTeam: 1, to: "Ramón Medina", sprint: 2 },
  { from: "Alitzel Sophia Camacho Flores", fromTeam: 5, to: "Cristina", sprint: 2 },
  { from: "Rodríguez Rodríguez Erick Tadeo", fromTeam: 7, to: "Monse", sprint: 2, reason: "Para el sprint 1 a mi compañera Ali" },
  { from: "Cruz Chávez Miguel Ángel", fromTeam: 7, to: "Arturo", sprint: 2 },
  { from: "Cristina Vianeth Saiz Perez", fromTeam: 5, to: "Ali", sprint: 2 },
  { from: "Bruno Aguilar Buendía", fromTeam: 4, to: "Fernando", sprint: 2 },
  { from: "Ximena Toledo Mendez", fromTeam: 5, to: "No", sprint: 2 },
  { from: "Gil De Gaona Jazmín", fromTeam: 1, to: "Ramón Medina", sprint: 2 },
  { from: "Antonio Velazquez Martinez", fromTeam: 2, to: "Moctezuma", sprint: 2 },
  { from: "Romero Velazquez Luis Fernando", fromTeam: 9, to: "Todo mi equipo", sprint: 2 },
  { from: "Carlos Emiliano Segura Loera", fromTeam: 2, to: "Samuel", sprint: 2 },
  { from: "Jose Angel Raygoza Islas", fromTeam: 3, to: "Todos", sprint: 2 },
  { from: "Armando Hernández González", fromTeam: 7, to: "Monserrat Hernández Martinez", sprint: 2 },
  { from: "Jesús Alvarez Casas", fromTeam: 10, to: "Rodrigo", sprint: 2 },
  { from: "Moctezuma Ramirez Diego Rafael", fromTeam: 2, to: "Samuel", sprint: 2 },
  { from: "Buenrostro Cruces Sarai", fromTeam: 1, to: "Ramon", sprint: 2 },
  { from: "González Sánchez Raúl Alejandro", fromTeam: 6, to: "Moctezuma Isidro Michelle", sprint: 2 },
  { from: "Cortes Cortes Bryan Yael", fromTeam: 9, to: "Cortes Cortes Bryan Yael", sprint: 2 },
  { from: "González Hernández Leslie Danaé", fromTeam: 8, to: "Vanesa Sebastián Cervantes", sprint: 2 },
  { from: "Saúl Villeda López", fromTeam: 2, to: "Samuel", sprint: 2 },
  { from: "Arturo Tadeo Moreno Vigueras", fromTeam: 7, to: "Monse", sprint: 2 },
  { from: "Monserrat Hernández Martínez", fromTeam: 7, to: "Monse jaja", sprint: 2 },
  { from: "Baez Villanueva Mauricio Omar", fromTeam: 8, to: "Lesly", sprint: 2 },
  { from: "Vanesa Sebastian Cervantes", fromTeam: 8, to: "Lesslie <3", sprint: 2 },
  { from: "Ríos Barrera Arantza Ilian", fromTeam: 9, to: "Yael Cortes", sprint: 2 },
  { from: "Rodrigo Rojas Uriositigue", fromTeam: 10, to: ".", sprint: 2 },
  { from: "Zaira Cecilia Perez Lopez", fromTeam: 1, to: "Ramon", sprint: 2 },
  { from: "Leonardo Daniel Velazquez Garcia", fromTeam: 10, to: "Rodrigo", sprint: 2 },
  { from: "Valdovinos Sedano Daniela Ariday", fromTeam: 9, to: "Yael Cortes", sprint: 2 },
  { from: "Marquez Espinoza Alyn Veronica", fromTeam: 7, to: "Monse", sprint: 2 },
  { from: "Romero Velazquez Luis Fernando (2)", fromTeam: 9, to: "Ari", sprint: 2 },
  { from: "Chávez González Itzel", fromTeam: 5, to: "Alitzel Camacho", sprint: 2 },
  { from: "Luna Martínez Escobar Guillermo", fromTeam: 10, to: "Rodrigo", sprint: 2 },
  { from: "Michelle Moctezuma Isidro", fromTeam: 6, to: "Luis David Elías García", sprint: 2 },
  { from: "Herrera Franco Samuel", fromTeam: 2, to: "Rafa", sprint: 2 },
  { from: "Daniela Itzel Mendoza Hernandez", fromTeam: 4, to: "Josue", sprint: 2 },
  { from: "Elías García Luis David", fromTeam: 6, to: "Michi", sprint: 2 },
  { from: "Martínez Hernández Ricardo Ramón", fromTeam: 10, to: "Ricardo", sprint: 2 },
  { from: "Herrera Hernández Diego", fromTeam: 8, to: "Vanesa", sprint: 2, reason: "Honestamente me sorprendió lo participativa que fue en este sprint, se adapto muy rápido al trabajo en postman y saco la chamba muy rapido, me gusta ese tipo de actitud que esta dispuesta a ganarse esa felicitación, ella se ofreció a hacer los métodos para cada endpoint, rechace esa idea porque pienso que cada uno de nosotros debería estar a la par en cuanto a conocimiento, pero si sento las bases de la documentación y fue la primera en hacer los métodos y la colección en postman" },
];

// ========================================
// HELPER FUNCTIONS PARA SPRINT 2
// ========================================

export const getSprint2DataByTeam = (teamId: number): SprintEvaluation[] => {
  return sprint2Data.filter(data => data.teamId === teamId);
};

export const getSprint2FelicitacionesByTeam = (teamId: number): Felicitacion[] => {
  return sprint2Felicitaciones.filter(f => f.fromTeam === teamId);
};

export const getSprint2FelicitacionesForPerson = (personName: string): Felicitacion[] => {
  const lowerName = personName.toLowerCase();
  return sprint2Felicitaciones.filter(f => 
    f.to.toLowerCase().includes(lowerName)
  );
};

// Conteo de felicitaciones para Sprint 2
export const countSprint2Felicitaciones = (): Map<string, number> => {
  const counts = new Map<string, number>();
  const displayNames = new Map<string, string>();
  
  sprint2Felicitaciones.forEach(f => {
    // Ignorar felicitaciones genéricas o vacías
    const lowerTo = f.to.toLowerCase();
    if (lowerTo.includes('todos') || lowerTo.includes('todo') || 
        lowerTo === 'no' || lowerTo === '.' || lowerTo === 'ninguno') {
      return;
    }
    
    const key = normalizeStudentNameSprint2(f.to);
    counts.set(key, (counts.get(key) || 0) + 1);
    
    if (!displayNames.has(key)) {
      displayNames.set(key, f.to);
    }
  });
  
  const result = new Map<string, number>();
  counts.forEach((count, key) => {
    const displayName = displayNames.get(key) || key;
    result.set(displayName, count);
  });
  
  return result;
};

// Normaliza nombres para agrupar variaciones
const normalizeStudentNameSprint2 = (name: string): string => {
  let normalized = name.toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  
  const nameAliases: Record<string, string> = {
    'monse': 'monse',
    'monserrat hernandez martinez': 'monse',
    'monse jaja': 'monse',
    'michelle': 'michelle',
    'moctezuma isidro michelle': 'michelle',
    'michi': 'michelle',
    'ramon': 'ramon',
    'ramon medina': 'ramon',
    'fernando': 'fernando',
    'josue': 'josue',
    'jose': 'josue',
    'bruno': 'bruno',
    'ali': 'ali',
    'alitzel camacho': 'ali',
    'cristina': 'cristina',
    'arturo': 'arturo',
    'vanesa': 'vanesa',
    'vanesa sebastian cervantes': 'vanesa',
    'lesly': 'lesly',
    'lesslie <3': 'lesly',
    'samuel': 'samuel',
    'yael cortes': 'yael',
    'emiliano': 'emiliano',
    'rodrigo': 'rodrigo',
    'moctezuma': 'moctezuma',
    'estefani lira': 'estefani',
    'pamela': 'pamela',
    'rafa': 'rafa',
    'luis david elias garcia': 'luis david',
    'ari': 'ari',
  };
  
  if (nameAliases[normalized]) {
    return nameAliases[normalized];
  }
  
  for (const [alias, canonical] of Object.entries(nameAliases)) {
    if (normalized.includes(alias) || alias.includes(normalized)) {
      return canonical;
    }
  }
  
  return normalized;
};
